
export { default as ClockIcon } from "./Clock.js"
export { default as PhoneIcon } from "./Phone.js"